var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 115,
    viewBox: "0 0 82 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "element",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 12,
    height: 11
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7905 10.425C18.6781 10.425 21.0189 8.09121 21.0189 5.21245C21.0189 2.33368 18.6781 0 15.7905 0C12.903 0 10.5621 2.33368 10.5621 5.21245C10.5621 8.09121 12.903 10.425 15.7905 10.425Z",
    fill: "url(#paint0_linear_21_5)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7905 10.425C18.6781 10.425 21.0189 8.09121 21.0189 5.21245C21.0189 2.33368 18.6781 0 15.7905 0C12.903 0 10.5621 2.33368 10.5621 5.21245C10.5621 8.09121 12.903 10.425 15.7905 10.425Z",
    fill: "url(#paint1_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 12,
    height: 11
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.0716 10.425C48.9592 10.425 51.3 8.09121 51.3 5.21245C51.3 2.33368 48.9592 0 46.0716 0C43.184 0 40.8432 2.33368 40.8432 5.21245C40.8432 8.09121 43.184 10.425 46.0716 10.425Z",
    fill: "url(#paint2_linear_21_5)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46.0716 10.425C48.9592 10.425 51.3 8.09121 51.3 5.21245C51.3 2.33368 48.9592 0 46.0716 0C43.184 0 40.8432 2.33368 40.8432 5.21245C40.8432 8.09121 43.184 10.425 46.0716 10.425Z",
    fill: "url(#paint3_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 0,
    width: 11,
    height: 11
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M76.3526 10.425C79.2402 10.425 81.581 8.09121 81.581 5.21245C81.581 2.33368 79.2402 0 76.3526 0C73.4651 0 71.1243 2.33368 71.1243 5.21245C71.1243 8.09121 73.4651 10.425 76.3526 10.425Z",
    fill: "url(#paint4_linear_21_5)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M76.3526 10.425C79.2402 10.425 81.581 8.09121 81.581 5.21245C81.581 2.33368 79.2402 0 76.3526 0C73.4651 0 71.1243 2.33368 71.1243 5.21245C71.1243 8.09121 73.4651 10.425 76.3526 10.425Z",
    fill: "url(#paint5_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 26,
    width: 12,
    height: 11
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.7905 36.5958C18.6781 36.5958 21.0189 34.2621 21.0189 31.3834C21.0189 28.5046 18.6781 26.171 15.7905 26.171C12.903 26.171 10.5621 28.5046 10.5621 31.3834C10.5621 34.2621 12.903 36.5958 15.7905 36.5958Z",
    fill: "url(#paint6_linear_21_5)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.7905 36.5958C18.6781 36.5958 21.0189 34.2621 21.0189 31.3834C21.0189 28.5046 18.6781 26.171 15.7905 26.171C12.903 26.171 10.5621 28.5046 10.5621 31.3834C10.5621 34.2621 12.903 36.5958 15.7905 36.5958Z",
    fill: "url(#paint7_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 26,
    width: 12,
    height: 11
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M46.0716 36.5958C48.9592 36.5958 51.3 34.2621 51.3 31.3834C51.3 28.5046 48.9592 26.171 46.0716 26.171C43.184 26.171 40.8432 28.5046 40.8432 31.3834C40.8432 34.2621 43.184 36.5958 46.0716 36.5958Z",
    fill: "url(#paint8_linear_21_5)"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M46.0716 36.5958C48.9592 36.5958 51.3 34.2621 51.3 31.3834C51.3 28.5046 48.9592 26.171 46.0716 26.171C43.184 26.171 40.8432 28.5046 40.8432 31.3834C40.8432 34.2621 43.184 36.5958 46.0716 36.5958Z",
    fill: "url(#paint9_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 26,
    width: 11,
    height: 11
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M76.3526 36.5958C79.2402 36.5958 81.581 34.2621 81.581 31.3834C81.581 28.5046 79.2402 26.171 76.3526 26.171C73.4651 26.171 71.1243 28.5046 71.1243 31.3834C71.1243 34.2621 73.4651 36.5958 76.3526 36.5958Z",
    fill: "url(#paint10_linear_21_5)"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M76.3526 36.5958C79.2402 36.5958 81.581 34.2621 81.581 31.3834C81.581 28.5046 79.2402 26.171 76.3526 26.171C73.4651 26.171 71.1243 28.5046 71.1243 31.3834C71.1243 34.2621 73.4651 36.5958 76.3526 36.5958Z",
    fill: "url(#paint11_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 52,
    width: 12,
    height: 11
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M15.7905 62.7125C18.6781 62.7125 21.0189 60.3788 21.0189 57.5C21.0189 54.6212 18.6781 52.2875 15.7905 52.2875C12.903 52.2875 10.5621 54.6212 10.5621 57.5C10.5621 60.3788 12.903 62.7125 15.7905 62.7125Z",
    fill: "url(#paint12_linear_21_5)"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.7905 62.7125C18.6781 62.7125 21.0189 60.3788 21.0189 57.5C21.0189 54.6212 18.6781 52.2875 15.7905 52.2875C12.903 52.2875 10.5621 54.6212 10.5621 57.5C10.5621 60.3788 12.903 62.7125 15.7905 62.7125Z",
    fill: "url(#paint13_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 52,
    width: 12,
    height: 11
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M46.0716 62.7125C48.9592 62.7125 51.3 60.3788 51.3 57.5C51.3 54.6212 48.9592 52.2875 46.0716 52.2875C43.184 52.2875 40.8432 54.6212 40.8432 57.5C40.8432 60.3788 43.184 62.7125 46.0716 62.7125Z",
    fill: "url(#paint14_linear_21_5)"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M46.0716 62.7125C48.9592 62.7125 51.3 60.3788 51.3 57.5C51.3 54.6212 48.9592 52.2875 46.0716 52.2875C43.184 52.2875 40.8432 54.6212 40.8432 57.5C40.8432 60.3788 43.184 62.7125 46.0716 62.7125Z",
    fill: "url(#paint15_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 52,
    width: 11,
    height: 11
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M76.3526 62.7125C79.2402 62.7125 81.581 60.3788 81.581 57.5C81.581 54.6212 79.2402 52.2875 76.3526 52.2875C73.4651 52.2875 71.1243 54.6212 71.1243 57.5C71.1243 60.3788 73.4651 62.7125 76.3526 62.7125Z",
    fill: "url(#paint16_linear_21_5)"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M76.3526 62.7125C79.2402 62.7125 81.581 60.3788 81.581 57.5C81.581 54.6212 79.2402 52.2875 76.3526 52.2875C73.4651 52.2875 71.1243 54.6212 71.1243 57.5C71.1243 60.3788 73.4651 62.7125 76.3526 62.7125Z",
    fill: "url(#paint17_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 78,
    width: 12,
    height: 11
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M15.7905 88.8834C18.6781 88.8834 21.0189 86.5496 21.0189 83.6709C21.0189 80.7921 18.6781 78.4584 15.7905 78.4584C12.903 78.4584 10.5621 80.7921 10.5621 83.6709C10.5621 86.5496 12.903 88.8834 15.7905 88.8834Z",
    fill: "url(#paint18_linear_21_5)"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M15.7905 88.8834C18.6781 88.8834 21.0189 86.5496 21.0189 83.6709C21.0189 80.7921 18.6781 78.4584 15.7905 78.4584C12.903 78.4584 10.5621 80.7921 10.5621 83.6709C10.5621 86.5496 12.903 88.8834 15.7905 88.8834Z",
    fill: "url(#paint19_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 78,
    width: 12,
    height: 11
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M46.0716 88.8834C48.9592 88.8834 51.3 86.5496 51.3 83.6709C51.3 80.7921 48.9592 78.4584 46.0716 78.4584C43.184 78.4584 40.8432 80.7921 40.8432 83.6709C40.8432 86.5496 43.184 88.8834 46.0716 88.8834Z",
    fill: "url(#paint20_linear_21_5)"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M46.0716 88.8834C48.9592 88.8834 51.3 86.5496 51.3 83.6709C51.3 80.7921 48.9592 78.4584 46.0716 78.4584C43.184 78.4584 40.8432 80.7921 40.8432 83.6709C40.8432 86.5496 43.184 88.8834 46.0716 88.8834Z",
    fill: "url(#paint21_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 78,
    width: 11,
    height: 11
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M76.3526 88.8834C79.2402 88.8834 81.581 86.5496 81.581 83.6709C81.581 80.7921 79.2402 78.4584 76.3526 78.4584C73.4651 78.4584 71.1243 80.7921 71.1243 83.6709C71.1243 86.5496 73.4651 88.8834 76.3526 88.8834Z",
    fill: "url(#paint22_linear_21_5)"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M76.3526 88.8834C79.2402 88.8834 81.581 86.5496 81.581 83.6709C81.581 80.7921 79.2402 78.4584 76.3526 78.4584C73.4651 78.4584 71.1243 80.7921 71.1243 83.6709C71.1243 86.5496 73.4651 88.8834 76.3526 88.8834Z",
    fill: "url(#paint23_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 104,
    width: 12,
    height: 11
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M15.7905 115C18.6781 115 21.0189 112.666 21.0189 109.788C21.0189 106.909 18.6781 104.575 15.7905 104.575C12.903 104.575 10.5621 106.909 10.5621 109.788C10.5621 112.666 12.903 115 15.7905 115Z",
    fill: "url(#paint24_linear_21_5)"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M15.7905 115C18.6781 115 21.0189 112.666 21.0189 109.788C21.0189 106.909 18.6781 104.575 15.7905 104.575C12.903 104.575 10.5621 106.909 10.5621 109.788C10.5621 112.666 12.903 115 15.7905 115Z",
    fill: "url(#paint25_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 104,
    width: 12,
    height: 11
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M46.0716 115C48.9592 115 51.3 112.666 51.3 109.788C51.3 106.909 48.9592 104.575 46.0716 104.575C43.184 104.575 40.8432 106.909 40.8432 109.788C40.8432 112.666 43.184 115 46.0716 115Z",
    fill: "url(#paint26_linear_21_5)"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M46.0716 115C48.9592 115 51.3 112.666 51.3 109.788C51.3 106.909 48.9592 104.575 46.0716 104.575C43.184 104.575 40.8432 106.909 40.8432 109.788C40.8432 112.666 43.184 115 46.0716 115Z",
    fill: "url(#paint27_linear_21_5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_21_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 104,
    width: 11,
    height: 11
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M76.3526 115C79.2402 115 81.581 112.666 81.581 109.788C81.581 106.909 79.2402 104.575 76.3526 104.575C73.4651 104.575 71.1243 106.909 71.1243 109.788C71.1243 112.666 73.4651 115 76.3526 115Z",
    fill: "url(#paint28_linear_21_5)"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_21_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M76.3526 115C79.2402 115 81.581 112.666 81.581 109.788C81.581 106.909 79.2402 104.575 76.3526 104.575C73.4651 104.575 71.1243 106.909 71.1243 109.788C71.1243 112.666 73.4651 115 76.3526 115Z",
    fill: "url(#paint29_linear_21_5)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_5",
    x1: 57.4049,
    y1: 110.551,
    x2: -13.9967,
    y2: -71.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_5",
    x1: 57.4049,
    y1: 110.551,
    x2: -13.9967,
    y2: -71.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_5",
    x1: 83.6091,
    y1: 100.259,
    x2: 12.2075,
    y2: -81.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_5",
    x1: 83.6091,
    y1: 100.259,
    x2: 12.2075,
    y2: -81.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21_5",
    x1: 109.813,
    y1: 89.9679,
    x2: 38.4119,
    y2: -91.8359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21_5",
    x1: 109.813,
    y1: 89.9679,
    x2: 38.4119,
    y2: -91.8359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_21_5",
    x1: 48.4624,
    y1: 114.062,
    x2: -22.9379,
    y2: -67.7403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_21_5",
    x1: 48.4624,
    y1: 114.062,
    x2: -22.9379,
    y2: -67.7403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_21_5",
    x1: 74.6667,
    y1: 103.771,
    x2: 3.26634,
    y2: -78.0318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_21_5",
    x1: 74.6667,
    y1: 103.771,
    x2: 3.26634,
    y2: -78.0318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_21_5",
    x1: 100.871,
    y1: 93.4794,
    x2: 29.4707,
    y2: -88.3231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_21_5",
    x1: 100.871,
    y1: 93.4794,
    x2: 29.4707,
    y2: -88.3231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_21_5",
    x1: 39.5201,
    y1: 117.575,
    x2: -31.8815,
    y2: -64.2288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_21_5",
    x1: 39.5201,
    y1: 117.575,
    x2: -31.8815,
    y2: -64.2288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_21_5",
    x1: 65.7243,
    y1: 107.283,
    x2: -5.67728,
    y2: -74.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_21_5",
    x1: 65.7243,
    y1: 107.283,
    x2: -5.67728,
    y2: -74.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_21_5",
    x1: 91.9287,
    y1: 96.9919,
    x2: 20.5271,
    y2: -84.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_21_5",
    x1: 91.9287,
    y1: 96.9919,
    x2: 20.5271,
    y2: -84.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_21_5",
    x1: 30.5777,
    y1: 121.087,
    x2: -40.8239,
    y2: -60.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_21_5",
    x1: 30.5777,
    y1: 121.087,
    x2: -40.8239,
    y2: -60.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_21_5",
    x1: 56.782,
    y1: 110.795,
    x2: -14.6196,
    y2: -71.0084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_21_5",
    x1: 56.782,
    y1: 110.795,
    x2: -14.6196,
    y2: -71.0084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_21_5",
    x1: 82.9863,
    y1: 100.504,
    x2: 11.5847,
    y2: -81.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_21_5",
    x1: 82.9863,
    y1: 100.504,
    x2: 11.5847,
    y2: -81.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_21_5",
    x1: 21.6353,
    y1: 124.599,
    x2: -49.7663,
    y2: -57.2047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_21_5",
    x1: 21.6353,
    y1: 124.599,
    x2: -49.7663,
    y2: -57.2047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_21_5",
    x1: 47.8397,
    y1: 114.307,
    x2: -23.562,
    y2: -67.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_21_5",
    x1: 47.8397,
    y1: 114.307,
    x2: -23.562,
    y2: -67.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_21_5",
    x1: 74.044,
    y1: 104.016,
    x2: 2.64237,
    y2: -77.7879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_21_5",
    x1: 74.044,
    y1: 104.016,
    x2: 2.64237,
    y2: -77.7879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.fd9cbd7075607ce208223840e677bcda.svg";
export { ForwardRef as ReactComponent };